import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-collection-points-operated-filters',
  templateUrl: './collection-points-operated-filters.component.html',
  styleUrls: ['./collection-points-operated-filters.component.scss']
})
export class CollectionPointsOperatedFiltersComponent implements OnInit {

  @Input()
  years!: number[];

  searchForm = this.formBuilder.group({
    year: ['']
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({year: this.yearControl.value} as IntelligenceSearchInterface);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.search.emit({} as IntelligenceSearchInterface);
  }

}
